export default function Card({ children, className = "", clickable = false, ...props }) {
  return (
    <section className={`card ${clickable ? "clickable" : ""} ${className}`.trim()} {...props}>
      {children}
    </section>
  );
}
